import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Media from "./Media";
import "./Home.css";
import Service from "./Service";
import About from "./About"
import Projects from "./Projects"
import web from "./../images/web-development.png";
import rightIm from "./../images/header-image.svg";
import rightIm2 from "./../images/header-image2.png";
import rightIm3 from "./../images/header-image3.png";
import axios from "axios";
import Contact from "./Contact"
import { motion, AnimatePresence } from "framer-motion";
import WOW from "wowjs"
import {
  Animator,
  ScrollContainer,
  ScrollPage,
  batch,
  Fade,
  MoveOut,
} from "react-scroll-motion";
function Home() {
  const [services, setServices] = useState([]);
  useEffect(() => {
    new WOW.WOW().init(); // Initialize WOW.js
  }, []);
  const slides = [
    {
      id: 1,
      title: "Elevate Your Business TO The Digital",
      description:
        "Wara Technology is a cutting-edge technology company dedicated to transforming your ideas into powerful digital solutions.",
      button: "Contact Us",
      image: rightIm,
    },
    {
      id: 2,
      title: "Innovative Solutions for Your Growth",
      description:
        "Empowering businesses with modern tools and strategies to thrive in a competitive digital landscape.",
      button: "Contact Us",
      image: rightIm2,
    },
    {
      id: 3,
      title: "Your Partner in Digital Transformation",
      description:
        "Seamlessly bridging the gap between technology and business to achieve extraordinary results.",
      button: "Contact Us",
      image: rightIm,
    },
  ];
const textVariant = {
  hidden: { opacity: 0, x: -50 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: 50 },
};

const imageVariant = {
  hidden: { opacity: 0, x: 50 },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0, x: -50 },
};
  const [currentIndex, setCurrentIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000); // Auto-slide every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="pt-2 px-3 md:px-6 w-full cont home">
      <motion.div
        key={currentIndex}
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ duration: 0.5 }}
        id="home"
        className="header_hero height-screen bg-gray lg:flex items-center w-full home_area transition-opacity duration-700 "
      >
        {/* Left Content */}
        <div className="container w-1/2">
          <div className="row">
            <div className="w-full lg:w-1/2 px-5 md:px-0 md:pr-8 ">
              <motion.div
                key={slides[currentIndex].title}
                variants={textVariant}
                transition={{ duration: 0.2 }}
                className="pt-20 "
              >
                <motion.p
                  variants={textVariant}
                  transition={{ duration: 0.5 }}
                  className="sm: text-3xl md:text-6xl lg:text-6xl xl:text-[80px] font-extrabold text-gray-950 font-play mr-10 md:mr-0"
                >
                  {slides[currentIndex].title}
                </motion.p>

                <motion.p
                  key={slides[currentIndex].description}
                  variants={textVariant}
                  transition={{ duration: 0.7 }}
                  className="mt-4 md:mt-8 lg:mr-12 leading-6 font-medium text-gray-950 text-base  md:text-lg lg:text-xl mr-4 md:mr-0"
                >
                  {slides[currentIndex].description}
                </motion.p>

                <motion.div
                  key={slides[currentIndex].button}
                  variants={textVariant}
                  transition={{ duration: 0.8 }}
                  className="hero_btn mt-4"
                >
                  <button
                    className="bg-[#eba82b] hover:bg-[#ed8936] active:bg-orange-700 focus:outline-none focus:ring focus:ring-orange-300 py-2 px-12 border rounded-full text-xl"
                    onClick={() => navigate("/contact")}
                  >
                    {slides[currentIndex].button}
                  </button>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="header_image flex md:pt-8 items-center">
          <div className="image">
            <motion.img
              key={slides[currentIndex].image}
              variants={imageVariant}
              transition={{ duration: 0.6 }}
              src={slides[currentIndex].image}
              className=""
              alt="Slide Image"
            />
          </div>
        </div>
      </motion.div>

      {/* service section */}
      <motion.div
        initial={{ opacity: 1, translateX: "50%" }}
        whileInView={{ opacity: 1, translateX: 0 }}
        exit="exit"
        transition={{ duration: 0.8 }}
      >
        <Service />
      </motion.div>
        <About />
      
      <motion.div
        initial={{ opacity: 1, translateY: "20%" }}
        whileInView={{ opacity: 1, translateY: 0 }}
        exit="exit"
        transition={{ duration: 1 }}
      >
        <Projects />
      </motion.div>
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.9 }}
        id="services"
        className="home_area pt-120 pb-120  "
      >
        {/* <div class=" w-full bg-white border border-gray-200 rounded-lg shadow-sm dark:bg-gray-800 dark:border-gray-700">
    
    <div id="fullWidthTabContent" class="border-t border-gray-200 dark:border-gray-600">
        <div class="p-4 bg-white rounded-lg md:p-8 dark:bg-neutral-800" id="stats" role="tabpanel" aria-labelledby="stats-tab">
            <dl class="grid max-w-screen-xl grid-cols-2 gap-8 p-4 mx-auto text-gray-900 sm:grid-cols-3 lg:flex lg:justify-between dark:text-white sm:p-8">
                <div class="flex flex-col items-center justify-center">
                    <dt class="mb-2 text-3xl font-extrabold">10+</dt>
                    <dd class="text-gray-500 dark:text-gray-400">Teams</dd>
                </div>
                <div class="flex flex-col items-center justify-center">
                    <dt class="mb-2 text-3xl font-extrabold">5+</dt>
                    <dd class="text-gray-500 dark:text-gray-400">Delivered projects</dd>
                </div>
                <div class="flex flex-col items-center justify-center">
                    <dt class="mb-2 text-3xl font-extrabold">10+</dt>
                    <dd class="text-gray-500 dark:text-gray-400">Pending projects</dd>
                </div>
                <div class="flex flex-col items-center justify-center">
                    <dt class="mb-2 text-3xl font-extrabold">15+</dt>
                    <dd class="text-gray-500 dark:text-gray-400">Customers</dd>
                </div>
                <div class="flex flex-col items-center justify-center">
                    <dt class="mb-2 text-3xl font-extrabold">90+</dt>
                    <dd class="text-gray-500 dark:text-gray-400">Top Forbes companies</dd>
                </div>
                <div class="flex flex-col items-center justify-center">
                    <dt class="mb-2 text-3xl font-extrabold">4M+</dt>
                    <dd class="text-gray-500 dark:text-gray-400">Organizations</dd>
                </div>
            </dl>
        </div>
        <div class="hidden p-4 bg-white rounded-lg md:p-8 dark:bg-gray-800" id="about" role="tabpanel" aria-labelledby="about-tab">
            <h2 class="mb-5 text-2xl font-extrabold tracking-tight text-gray-900 dark:text-white">We invest in the world’s potential</h2>
            <ul role="list" class="space-y-4 text-gray-500 dark:text-gray-400">
                <li class="flex space-x-2 rtl:space-x-reverse items-center">
                    <svg class="shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                    </svg>
                    <span class="leading-tight">Dynamic reports and dashboards</span>
                </li>
                <li class="flex space-x-2 rtl:space-x-reverse items-center">
                    <svg class="shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                    </svg>
                    <span class="leading-tight">Templates for everyone</span>
                </li>
                <li class="flex space-x-2 rtl:space-x-reverse items-center">
                    <svg class="shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                    </svg>
                    <span class="leading-tight">Development workflow</span>
                </li>
                <li class="flex space-x-2 rtl:space-x-reverse items-center">
                    <svg class="shrink-0 w-3.5 h-3.5 text-blue-600 dark:text-blue-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z"/>
                    </svg>
                    <span class="leading-tight">Limitless business automation</span>
                </li>
            </ul>
        </div>
        <div class="hidden p-4 bg-white rounded-lg dark:bg-gray-800" id="faq" role="tabpanel" aria-labelledby="faq-tab">
            <div id="accordion-flush" data-accordion="collapse" data-active-classes="bg-white dark:bg-gray-800 text-gray-900 dark:text-white" data-inactive-classes="text-gray-500 dark:text-gray-400">
                <h2 id="accordion-flush-heading-1">
                    <button type="button" class="flex items-center justify-between w-full py-5 font-medium text-left rtl:text-right text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" data-accordion-target="#accordion-flush-body-1" aria-expanded="true" aria-controls="accordion-flush-body-1">
                    <span>What is Flowbite?</span>
                    <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </svg>
                    </button>
                </h2>
                <div id="accordion-flush-body-1" class="hidden" aria-labelledby="accordion-flush-heading-1">
                    <div class="py-5 border-b border-gray-200 dark:border-gray-700">
                    <p class="mb-2 text-gray-500 dark:text-gray-400">Flowbite is an open-source library of interactive components built on top of Tailwind CSS including buttons, dropdowns, modals, navbars, and more.</p>
                    <p class="text-gray-500 dark:text-gray-400">Check out this guide to learn how to <a href="/docs/getting-started/introduction/" class="text-blue-600 dark:text-blue-500 hover:underline">get started</a> and start developing websites even faster with components on top of Tailwind CSS.</p>
                    </div>
                </div>
                <h2 id="accordion-flush-heading-2">
                    <button type="button" class="flex items-center justify-between w-full py-5 font-medium text-left rtl:text-right text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" data-accordion-target="#accordion-flush-body-2" aria-expanded="false" aria-controls="accordion-flush-body-2">
                    <span>Is there a Figma file available?</span>
                    <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </svg>
                    </button>
                </h2>
                <div id="accordion-flush-body-2" class="hidden" aria-labelledby="accordion-flush-heading-2">
                    <div class="py-5 border-b border-gray-200 dark:border-gray-700">
                    <p class="mb-2 text-gray-500 dark:text-gray-400">Flowbite is first conceptualized and designed using the Figma software so everything you see in the library has a design equivalent in our Figma file.</p>
                    <p class="text-gray-500 dark:text-gray-400">Check out the <a href="https://flowbite.com/figma/" class="text-blue-600 dark:text-blue-500 hover:underline">Figma design system</a> based on the utility classes from Tailwind CSS and components from Flowbite.</p>
                    </div>
                </div>
                <h2 id="accordion-flush-heading-3">
                    <button type="button" class="flex items-center justify-between w-full py-5 font-medium text-left rtl:text-right text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400" data-accordion-target="#accordion-flush-body-3" aria-expanded="false" aria-controls="accordion-flush-body-3">
                    <span>What are the differences between Flowbite and Tailwind UI?</span>
                    <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
                    </svg>
                    </button>
                </h2>
                <div id="accordion-flush-body-3" class="hidden" aria-labelledby="accordion-flush-heading-3">
                    <div class="py-5 border-b border-gray-200 dark:border-gray-700">
                    <p class="mb-2 text-gray-500 dark:text-gray-400">The main difference is that the core components from Flowbite are open source under the MIT license, whereas Tailwind UI is a paid product. Another difference is that Flowbite relies on smaller and standalone components, whereas Tailwind UI offers sections of pages.</p>
                    <p class="mb-2 text-gray-500 dark:text-gray-400">However, we actually recommend using both Flowbite, Flowbite Pro, and even Tailwind UI as there is no technical reason stopping you from using the best of two worlds.</p>
                    <p class="mb-2 text-gray-500 dark:text-gray-400">Learn more about these technologies:</p>
                    <ul class="ps-5 text-gray-500 list-disc dark:text-gray-400">
                        <li><a href="https://flowbite.com/pro/" class="text-blue-600 dark:text-blue-500 hover:underline">Flowbite Pro</a></li>
                        <li><a href="https://tailwindui.com/" rel="nofollow" class="text-blue-600 dark:text-blue-500 hover:underline">Tailwind UI</a></li>
                    </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> */}

        {/* container  */}
        <section class="mt-20">
          <div class="container">
            <div class="flex justify-center ">
              <h2 class="text-3xl md:text-4xl lg:text-6xl font-bold font-play">
                Our Core Qualities
              </h2>
            </div>
            <div class="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              <div class="mb-8 ">
                <div class="rounded-xl bg-white p-6 shadow-lg lg:p-8">
                  <div class="gradient-number relative inline-block">
                    <span class="bg-gradient-to-r from-red-500 via-orange-500 to-yellow-400 inline-block text-transparent bg-clip-text absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-4xl font-bold">
                      01
                    </span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M42.8833 0.00928958C63.2143 -0.38584 82.2759 11.853 88.3264 31.1979C94.1797 49.9121 84.027 68.9907 68.0244 80.3913C52.4387 91.4948 31.5679 93.9094 16.0849 82.6642C0.66775 71.4667 -3.27813 50.9537 2.58684 32.8642C8.48561 14.6704 23.699 0.382132 42.8833 0.00928958Z"
                        fill="#FFCC99"
                      />
                    </svg>
                  </div>
                  <h4 class="my-6 text-2xl md:text-3xl lg:text-4xl font-semibold font-play">
                    Accessibility
                  </h4>
                  <p className="font-playo text-base md:text-lg lg:text-xl text-gray-500">
                    Providing user-friendly and inclusive solutions that ensure
                    everyone can easily access and benefit from the software,
                    regardless of their abilities or technical expertise.
                  </p>
                </div>
              </div>
              <div class="mb-8 ">
                <div class="rounded-xl bg-white p-6 shadow-lg lg:p-8">
                  <div class="gradient-number relative inline-block">
                    <span class="bg-gradient-to-r from-red-500 via-orange-500 to-yellow-400 inline-block text-transparent bg-clip-text  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-4xl font-bold">
                      02
                    </span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M42.8833 0.00928958C63.2143 -0.38584 82.2759 11.853 88.3264 31.1979C94.1797 49.9121 84.027 68.9907 68.0244 80.3913C52.4387 91.4948 31.5679 93.9094 16.0849 82.6642C0.66775 71.4667 -3.27813 50.9537 2.58684 32.8642C8.48561 14.6704 23.699 0.382132 42.8833 0.00928958Z"
                        fill="#FFCC99"
                      />
                    </svg>
                  </div>
                  <h4 class="my-6 text-2xl md:text-3xl lg:text-4xl font-semibold font-play">
                    Empowerement
                  </h4>
                  <p className="font-playo text-base md:text-lg lg:text-xl text-gray-500">
                    Enabling clients and users with tools and technologies that
                    enhance their productivity, decision-making, and ability to
                    achieve their goals effectively.
                  </p>
                </div>
              </div>
              <div class="mb-8 ">
                <div class="rounded-xl bg-white p-6 shadow-lg lg:p-8">
                  <div class="gradient-number relative inline-block">
                    <span class="bg-gradient-to-r from-red-500 via-orange-500 to-yellow-400 inline-block text-transparent bg-clip-text  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-4xl font-bold">
                      03
                    </span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M42.8833 0.00928958C63.2143 -0.38584 82.2759 11.853 88.3264 31.1979C94.1797 49.9121 84.027 68.9907 68.0244 80.3913C52.4387 91.4948 31.5679 93.9094 16.0849 82.6642C0.66775 71.4667 -3.27813 50.9537 2.58684 32.8642C8.48561 14.6704 23.699 0.382132 42.8833 0.00928958Z"
                        fill="#FFCC99"
                      />
                    </svg>
                  </div>
                  <h4 class="my-6 text-2xl md:text-3xl lg:text-4xl font-semibold font-play">
                    Innovation
                  </h4>
                  <p className="font-playo text-base md:text-lg lg:text-xl text-gray-500">
                    Leveraging cutting-edge technologies and creative thinking
                    to deliver unique, forward-looking software solutions that
                    solve complex challenges.
                  </p>
                </div>
              </div>
              <div class="mb-8 ">
                <div class="rounded-xl bg-white p-6 shadow-lg lg:p-8">
                  <div class="gradient-number relative inline-block">
                    <span class="bg-gradient-to-r from-red-500 via-orange-500 to-yellow-400 inline-block text-transparent bg-clip-text  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-4xl font-bold">
                      04
                    </span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M42.8833 0.00928958C63.2143 -0.38584 82.2759 11.853 88.3264 31.1979C94.1797 49.9121 84.027 68.9907 68.0244 80.3913C52.4387 91.4948 31.5679 93.9094 16.0849 82.6642C0.66775 71.4667 -3.27813 50.9537 2.58684 32.8642C8.48561 14.6704 23.699 0.382132 42.8833 0.00928958Z"
                        fill="#FFCC99"
                      />
                    </svg>
                  </div>
                  <h4 class="my-6 text-2xl md:text-3xl lg:text-4xl font-semibold font-play">
                    Excellence
                  </h4>
                  <p className="font-playo text-base md:text-lg lg:text-xl text-gray-500">
                    Maintaining the highest standards of quality in software
                    design, development, and support, ensuring client
                    satisfaction and long-term value
                  </p>
                </div>
              </div>
              <div class="mb-8 ">
                <div class="rounded-xl bg-white p-6 shadow-lg lg:p-8">
                  <div class="gradient-number relative inline-block">
                    <span class="bg-gradient-to-r from-red-500 via-orange-500 to-yellow-400 inline-block text-transparent bg-clip-text  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-4xl font-bold">
                      05
                    </span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M42.8833 0.00928958C63.2143 -0.38584 82.2759 11.853 88.3264 31.1979C94.1797 49.9121 84.027 68.9907 68.0244 80.3913C52.4387 91.4948 31.5679 93.9094 16.0849 82.6642C0.66775 71.4667 -3.27813 50.9537 2.58684 32.8642C8.48561 14.6704 23.699 0.382132 42.8833 0.00928958Z"
                        fill="#FFCC99"
                      />
                    </svg>
                  </div>
                  <h4 class="my-6 text-2xl md:text-3xl lg:text-4xl font-semibold font-play">
                    Team work
                  </h4>
                  <p className="font-playo text-base md:text-lg lg:text-xl text-gray-500">
                    Fostering collaboration within diverse, skilled teams and
                    with clients to ensure the delivery of cohesive,
                    well-integrated solutions.
                  </p>
                </div>
              </div>
              <div class="mb-8 ">
                <div class="rounded-xl bg-white p-6 shadow-lg lg:p-8">
                  <div class="gradient-number relative inline-block">
                    <span class="bg-gradient-to-r from-red-500 via-orange-500 to-yellow-400 inline-block text-transparent bg-clip-text  absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-4xl font-bold">
                      06
                    </span>
                    <svg
                      width="40"
                      height="40"
                      viewBox="0 0 90 90"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.1"
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M42.8833 0.00928958C63.2143 -0.38584 82.2759 11.853 88.3264 31.1979C94.1797 49.9121 84.027 68.9907 68.0244 80.3913C52.4387 91.4948 31.5679 93.9094 16.0849 82.6642C0.66775 71.4667 -3.27813 50.9537 2.58684 32.8642C8.48561 14.6704 23.699 0.382132 42.8833 0.00928958Z"
                        fill="#FFCC99"
                      />
                    </svg>
                  </div>
                  <h4 class="my-6 text-2xl md:text-3xl lg:text-4xl font-semibold font-play">
                    Responsibility
                  </h4>
                  <p className="font-playo text-base md:text-lg lg:text-xl text-gray-500">
                    Commitment to ethical practices, timely project delivery,
                    and creating reliable, secure, and sustainable software
                    systems that meet client expectations
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </motion.div>
      <div className="">
        <div className="py-4 my-4 text-center ">
          <h1 className="font-play text-4xl">Our Clients</h1>
          <hr className="" />
        </div>
      </div>
      <Contact/>
      <Media />
    </div>
  );
}

export default Home;
